import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Public pages
import Home from './pages/public/Home';
import About from './pages/public/About';
import Contact from './pages/public/Contact';
import ClientsServices from './pages/public/ClientsServices';
import Blog from './pages/public/Blog';
import BlogPost from './pages/public/BlogPost';
import Products from './pages/public/Products';
import ProductDetail from './pages/public/ProductDetail';
import Cart from './pages/public/Cart';
import Location from './pages/public/Location';

// Auth pages
import Login from './pages/auth/Login';

// Admin pages
import AdminDashboard from './pages/admin/AdminDashboard';
import ThemeSettings from './pages/admin/ThemeSettings';
import PageEditor from './pages/admin/PageEditor';
import SuccessStoriesManager from './pages/admin/SuccessStoriesManager';
import ClientsServicesManager from './pages/admin/ClientsServicesManager';
import BlogManager from './pages/admin/BlogManager';
import MediaManager from './pages/admin/MediaManager';
import ContactSubmissions from './pages/admin/ContactSubmissions';
import FooterSettings from './pages/admin/FooterSettings';
import Preview from './pages/admin/Preview';
import ProductsManager from './pages/admin/ProductsManager';
import HomepageComponentsManager from './pages/admin/HomepageComponentsManager';
import NavigationManager from './pages/admin/NavigationManager';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import PrivateRoute from './components/PrivateRoute';

// Context
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <div className="App">
            <Navbar />
            <main className="main-content">
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/clients-services" element={<ClientsServices />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:id" element={<ProductDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/location" element={<Location />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />

                {/* Auth Routes */}
                <Route path="/login" element={<Login />} />

                {/* Admin Routes */}
                <Route
                  path="/admin"
                  element={
                    <PrivateRoute>
                      <AdminDashboard />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin/theme"
                  element={
                    <PrivateRoute>
                      <ThemeSettings />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin/pages/:slug"
                  element={
                    <PrivateRoute>
                      <PageEditor />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin/success-stories"
                  element={
                    <PrivateRoute>
                      <SuccessStoriesManager />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin/clients-services"
                  element={
                    <PrivateRoute>
                      <ClientsServicesManager />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin/blog"
                  element={
                    <PrivateRoute>
                      <BlogManager />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin/media"
                  element={
                    <PrivateRoute>
                      <MediaManager />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin/contact-submissions"
                  element={
                    <PrivateRoute>
                      <ContactSubmissions />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin/footer"
                  element={
                    <PrivateRoute>
                      <FooterSettings />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin/preview/:slug"
                  element={
                    <PrivateRoute>
                      <Preview />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin/products"
                  element={
                    <PrivateRoute>
                      <ProductsManager />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin/homepage-components"
                  element={
                    <PrivateRoute>
                      <HomepageComponentsManager />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin/navigation"
                  element={
                    <PrivateRoute>
                      <NavigationManager />
                    </PrivateRoute>
                  }
                />

                {/* Catch all */}
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
